function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import styles from './LemonReset.css';

var LemonReset = function LemonReset(_ref) {
    var Tag = _ref.tag,
        children = _ref.children,
        className = _ref.className,
        tagRef = _ref.tagRef,
        otherProps = _objectWithoutProperties(_ref, ['tag', 'children', 'className', 'tagRef']);

    var classes = styles['lemon--' + Tag];
    if (className != null && className !== '') {
        classes += ' ' + className;
    }
    return React.createElement(
        Tag,
        Object.assign({ className: classes, ref: tagRef }, otherProps),
        children
    );
};

export { LemonReset };
LemonReset.displayName = 'LemonReset';

LemonReset.defaultProps = {
    children: null,
    className: '',
    tagRef: null
};

function createTagComponent(tag, displayName) {
    var component = function component(props) {
        return React.createElement(LemonReset, Object.assign({ tag: tag }, props));
    };
    component.defaultProps = {
        className: ''
    };
    component.displayName = displayName;
    return component;
}

function createNoChildTagComponent(tag, displayName) {
    var component = function component(props) {
        return React.createElement(LemonReset, Object.assign({ tag: tag }, props));
    };
    component.defaultProps = {
        children: null,
        className: ''
    };
    component.displayName = displayName;
    return component;
}

export var Embed = createNoChildTagComponent('embed', 'Embed');
export var Img = createNoChildTagComponent('img', 'Img');

export var A = createTagComponent('a', 'A');
export var Abbr = createTagComponent('abbr', 'Abbr');
export var Acronym = createTagComponent('acronym', 'Acronym');
export var Address = createTagComponent('address', 'Address');
export var Applet = createTagComponent('applet', 'Applet');
export var Article = createTagComponent('article', 'Article');
export var Aside = createTagComponent('aside', 'Aside');
export var Audio = createTagComponent('audio', 'Audio');
export var B = createTagComponent('b', 'B');
export var Big = createTagComponent('big', 'Big');
export var Blockquote = createTagComponent('blockquote', 'Blockquote');
export var Canvas = createTagComponent('canvas', 'Canvas');
export var Caption = createTagComponent('caption', 'Caption');
export var Center = createTagComponent('center', 'Center');
export var Cite = createTagComponent('cite', 'Cite');
export var Code = createTagComponent('code', 'Code');
export var Dd = createTagComponent('dd', 'Dd');
export var Del = createTagComponent('del', 'Del');
export var Details = createTagComponent('details', 'Details');
export var Dfn = createTagComponent('dfn', 'Dfn');
export var Div = createTagComponent('div', 'Div');
export var Dl = createTagComponent('dl', 'Dl');
export var DomObject = createTagComponent('object', 'DomObject');
export var Dt = createTagComponent('dt', 'Dt');
export var Em = createTagComponent('em', 'Em');
export var Fieldset = createTagComponent('fieldset', 'Fieldset');
export var Figcaption = createTagComponent('figcaption', 'Figcaption');
export var Figure = createTagComponent('figure', 'Figure');
export var Footer = createTagComponent('footer', 'Footer');
export var Form = createTagComponent('form', 'Form');
export var H1 = createTagComponent('h1', 'H1');
export var H2 = createTagComponent('h2', 'H2');
export var H3 = createTagComponent('h3', 'H3');
export var H4 = createTagComponent('h4', 'H4');
export var H5 = createTagComponent('h5', 'H5');
export var H6 = createTagComponent('h6', 'H6');
export var Header = createTagComponent('header', 'Header');
export var Hgroup = createTagComponent('hgroup', 'Hgroup');
export var I = createTagComponent('i', 'I');
export var Iframe = createTagComponent('iframe', 'Iframe');
export var Ins = createTagComponent('ins', 'Ins');
export var Kbd = createTagComponent('kbd', 'Kbd');
export var Label = createTagComponent('label', 'Label');
export var Legend = createTagComponent('legend', 'Legend');
export var Li = createTagComponent('li', 'Li');
export var Mark = createTagComponent('mark', 'Mark');
export var Menu = createTagComponent('menu', 'Menu');
export var Nav = createTagComponent('nav', 'Nav');
export var Ol = createTagComponent('ol', 'Ol');
export var Output = createTagComponent('output', 'Output');
export var P = createTagComponent('p', 'P');
export var Pre = createTagComponent('pre', 'Pre');
export var Q = createTagComponent('q', 'Q');
export var Ruby = createTagComponent('ruby', 'Ruby');
export var S = createTagComponent('s', 'S');
export var Samp = createTagComponent('samp', 'Samp');
export var Section = createTagComponent('section', 'Section');
export var Small = createTagComponent('small', 'Small');
export var Span = createTagComponent('span', 'Span');
export var Strike = createTagComponent('strike', 'Strike');
export var Strong = createTagComponent('strong', 'Strong');
export var Sub = createTagComponent('sub', 'Sub');
export var Summary = createTagComponent('summary', 'Summary');
export var Sup = createTagComponent('sup', 'Sup');
export var Table = createTagComponent('table', 'Table');
export var Tbody = createTagComponent('tbody', 'Tbody');
export var Td = createTagComponent('td', 'Td');
export var Tfoot = createTagComponent('tfoot', 'Tfoot');
export var Th = createTagComponent('th', 'Th');
export var Thead = createTagComponent('thead', 'Thead');
export var Time = createTagComponent('time', 'Time');
export var Tr = createTagComponent('tr', 'Tr');
export var Tt = createTagComponent('tt', 'Tt');
export var U = createTagComponent('u', 'U');
export var Ul = createTagComponent('ul', 'Ul');
export var Var = createTagComponent('var', 'Var');
export var Video = createTagComponent('video', 'Video');